<mat-form-field class="chips">
  <mat-chip-grid #chipList (ngModelChange)="rule.value = $event; onChange()" [ngModel]="rule.value">

    @if (rule.value.length < 50) {
      @for (item of rule.value; track item) {
        <mat-chip-row (removed)="remove(item)" [removable]="true">
          <span>{{ item }}</span>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
    } @else {
      <cdk-virtual-scroll-viewport class="virtual-chips" [itemSize]="40">
        <div *cdkVirtualFor="let item of rule.value" class="virtual-chip-row">
          <mat-chip-option (removed)="remove(item)" [removable]="true">
            <span>{{ item }}</span>
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-option>
        </div>
      </cdk-virtual-scroll-viewport>
    }

    <input #input
      (blur)="append('single', input)"
      (keypress)="isTrustedKey($event.ctrlKey, $event.keyCode)"
      (keyup.alt.enter)="append('many', input)"
      (keyup.enter)="append('single', input)"
      (paste)="paste($event)"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separators"
      matInput
      type="text">
  </mat-chip-grid>
  <app-upload-file-button (loaded)="appendValues($event)" matSuffix>
  </app-upload-file-button>
</mat-form-field>
